// extracted by mini-css-extract-plugin
export default {"supportMessage":"WithdrawalMessage_supportMessage__PkXe3","supportMessage_title":"WithdrawalMessage_supportMessage_title__YTZWr"};